import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';

export default function Komisyonlar() {
  const { profil } = useAuth();
  const [temsilciler, setTemsilciler] = useState([]);
  const [seciliTemsilci, setSeciliTemsilci] = useState('');
  const [komisyonlar, setKomisyonlar] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [odemeler, setOdemeler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tarihBas, setTarihBas] = useState('');
  const [tarihBit, setTarihBit] = useState('');
  const [tanimModal, setTanimModal] = useState(false);
  const [tanimForm, setTanimForm] = useState({ firma_id: '', oran: '' });
  const [tab, setTab] = useState('detay');
  const [altKomisyonlar, setAltKomisyonlar] = useState([]);
  const [temsilciAltMi, setTemsilciAltMi] = useState(false);
  const [altTemsilciOran, setAltTemsilciOran] = useState(75);
  const [secili, setSecili] = useState({});          // komisyon odemesi icin secili siparis id'leri
  const [odemeKaydediliyor, setOdemeKaydediliyor] = useState(false);
  const [eldenTahsilat, setEldenTahsilat] = useState('');
  const [komFiltre, setKomFiltre] = useState('odenmemis'); // odenmemis | odenmis | hepsi

  useEffect(() => {
    fetchFirmalar();
    if (profil?.rol === 'temsilci') { setSeciliTemsilci(profil.id); }
    else { fetchTemsilciler(); }
  }, []);

  useEffect(() => { setSecili({}); setEldenTahsilat(''); if (seciliTemsilci) fetchKomisyonlar(); }, [seciliTemsilci, tarihBas, tarihBit]);

  async function fetchFirmalar() { const { data } = await supabase.from('firmalar').select('id, ad').eq('aktif', true); setFirmalar(data || []); }
  async function fetchTemsilciler() { const { data } = await supabase.from('kullanicilar').select('id, ad, soyad').in('rol', ['temsilci', 'admin']).eq('aktif', true); setTemsilciler(data || []); }

  async function fetchKomisyonlar() {
    setLoading(true);
    // Alt temsilci mi kontrol et
    const { data: temsilciInfo } = await supabase
      .from('kullanicilar')
      .select('ust_temsilci_id, alt_temsilci_komisyon_orani')
      .eq('id', seciliTemsilci)
      .maybeSingle();
    setTemsilciAltMi(temsilciInfo?.ust_temsilci_id ? true : false);
    setAltTemsilciOran(temsilciInfo?.alt_temsilci_komisyon_orani || 75);

    let q = supabase.from('siparisler').select('*, firmalar(ad)').eq('temsilci_id', seciliTemsilci).not('siparis_durumu', 'eq', 'iptal').eq('odeme_durumu', 'odendi'); // FIX: Sadece ödenmiş siparişlerin komisyonu
    if (tarihBas) q = q.gte('created_at', tarihBas);
    if (tarihBit) q = q.lte('created_at', tarihBit + 'T23:59:59');
    const { data: s } = await q;
    const { data: o } = await supabase.from('komisyon_odemeleri').select('*').eq('temsilci_id', seciliTemsilci).order('created_at', { ascending: false });

    // Üst temsilci mi? Sadece ödenmiş siparişlerin alt temsilci paylarını çek
    const { data: odenmisIds } = await supabase
      .from('siparisler')
      .select('id')
      .eq('odeme_durumu', 'odendi');
    const odenmisIdList = (odenmisIds || []).map(s => s.id);

    const { data: altKomisyonlar } = odenmisIdList.length > 0
      ? await supabase
          .from('ust_temsilci_komisyonlar')
          .select('*, kullanicilar!alt_temsilci_id(ad, soyad), siparisler(siparis_no)')
          .eq('ust_temsilci_id', seciliTemsilci)
          .in('siparis_id', odenmisIdList)
          .order('created_at', { ascending: false })
      : { data: [] };

    setKomisyonlar(s || []);
    setOdemeler(o || []);
    setAltKomisyonlar(altKomisyonlar || []);
    setLoading(false);
  }

  // DB'de siparisler.toplam_komisyon zaten alt temsilcinin payı olarak yazılıyor (altPay)
  // Bu yüzden burada tekrar çarpmaya gerek yok, direkt topla
  const toplamHakEdilen = komisyonlar.reduce((a, s) => a + (s.toplam_komisyon || 0), 0);
  const altTemsilciToplam = altKomisyonlar.reduce((a, k) => a + (k.ust_temsilci_payi || 0), 0);
  const genelToplam = toplamHakEdilen + altTemsilciToplam;
  // Ödenen / Bekleyen'i doğrudan siparişlerin komisyon_odendi işaretinden hesapla (senkron sorunu olmasın)
  const odenmisKomisyon = komisyonlar.filter(s => s.komisyon_odendi).reduce((a, s) => a + (s.toplam_komisyon || 0), 0);
  const bekleyenKomisyon = komisyonlar.filter(s => !s.komisyon_odendi).reduce((a, s) => a + (s.toplam_komisyon || 0), 0);
  const toplamOdenen = odenmisKomisyon;
  const toplamEldenMahsup = odemeler.reduce((a, o) => a + (Number(o.elden_tahsilat) || 0), 0);
  const netOdenen = toplamOdenen - toplamEldenMahsup;
  const bekleyen = bekleyenKomisyon;

  const firmaKomisyon = firmalar.map(f => ({ firma: f.ad, tutar: komisyonlar.filter(s => s.firma_id === f.id).reduce((a, s) => a + (s.toplam_komisyon || 0), 0) })).filter(f => f.tutar > 0);

  const seciliIdler = Object.keys(secili).filter(id => secili[id]);
  const seciliToplam = komisyonlar
    .filter(s => seciliIdler.includes(s.id))
    .reduce((a, s) => a + (s.toplam_komisyon || 0), 0);

  function tumunuSec() {
    const odenmemisler = komisyonlar.filter(s => !s.komisyon_odendi);
    if (seciliIdler.length === odenmemisler.length && odenmemisler.length > 0) {
      setSecili({});
    } else {
      const yeni = {};
      odenmemisler.forEach(s => { yeni[s.id] = true; });
      setSecili(yeni);
    }
  }

  async function komisyonOde() {
    if (seciliIdler.length === 0) return;
    const elden = Number(eldenTahsilat) || 0;
    const net = seciliToplam - elden;
    if (!window.confirm(
      `${seciliIdler.length} siparişin komisyonu "ödendi" olarak işaretlenecek.\n` +
      `Komisyon toplamı: ${fmt(seciliToplam)} ₺\n` +
      (elden > 0 ? `Elden tahsilat (mahsup): ${fmt(elden)} ₺\nÖdenecek net: ${fmt(net)} ₺\n` : '') +
      `\nOnaylıyor musunuz?`
    )) return;

    setOdemeKaydediliyor(true);
    // 1) Odeme kaydi olustur (komisyon toplami + elden tahsilat ayri tutulur)
    const { data: odeme, error: odemeHata } = await supabase.from('komisyon_odemeleri').insert({
      temsilci_id: seciliTemsilci,
      tutar: seciliToplam,
      elden_tahsilat: elden,
      not_: `${seciliIdler.length} sipariş komisyonu` + (elden > 0 ? ` (elden mahsup: ${fmt(elden)} ₺, net: ${fmt(net)} ₺)` : ''),
      siparis_ids: seciliIdler,
      created_by: profil?.id,
    }).select('id').maybeSingle();

    if (odemeHata) { setOdemeKaydediliyor(false); alert('Ödeme kaydı hatası: ' + odemeHata.message); return; }

    // 2) Siparisleri isaretle
    const { error: updHata } = await supabase.from('siparisler')
      .update({ komisyon_odendi: true, komisyon_odeme_id: odeme?.id || null })
      .in('id', seciliIdler);

    setOdemeKaydediliyor(false);
    if (updHata) { alert('Sipariş güncelleme hatası: ' + updHata.message); return; }

    setSecili({});
    setEldenTahsilat('');
    fetchKomisyonlar();
  }

  async function komisyonGeriAl(siparisId) {
    if (!window.confirm('Bu siparişin komisyon ödemesi işareti kaldırılsın mı?')) return;
    await supabase.from('siparisler').update({ komisyon_odendi: false, komisyon_odeme_id: null }).eq('id', siparisId);
    fetchKomisyonlar();
  }

  async function temsilciTumunuGeriAl() {
    if (!seciliTemsilci) return;
    const secilenAd = temsilciler.find(t => t.id === seciliTemsilci);
    const adYazi = secilenAd ? `${secilenAd.ad} ${secilenAd.soyad}` : 'bu temsilci';
    if (!window.confirm(
      `DİKKAT: ${adYazi} temsilcisinin TÜM komisyon ödeme işaretleri kaldırılacak ve ödeme kayıtları silinecek.\n\n` +
      `Tüm siparişleri "Ödenmedi" durumuna dönecek. Bu işlem geri alınamaz.\n\nDevam edilsin mi?`
    )) return;

    setOdemeKaydediliyor(true);
    // 1) Bu temsilcinin tum siparislerinin isaretini kaldir
    const { error: updHata } = await supabase.from('siparisler')
      .update({ komisyon_odendi: false, komisyon_odeme_id: null })
      .eq('temsilci_id', seciliTemsilci);
    // 2) Bu temsilcinin tum odeme kayitlarini sil
    const { error: delHata } = await supabase.from('komisyon_odemeleri')
      .delete().eq('temsilci_id', seciliTemsilci);
    setOdemeKaydediliyor(false);

    if (updHata || delHata) { alert('Hata: ' + ((updHata || delHata).message)); return; }
    setSecili({});
    setEldenTahsilat('');
    fetchKomisyonlar();
  }

  async function handleTanimKaydet() {
    if (!tanimForm.firma_id || !tanimForm.oran) return;
    await supabase.from('komisyon_tanimlar').upsert({ temsilci_id: seciliTemsilci, firma_id: tanimForm.firma_id, oran: parseFloat(tanimForm.oran) }, { onConflict: 'temsilci_id,firma_id' });
    setTanimModal(false);
  }

  const fmt = v => (v || 0).toLocaleString('tr-TR');

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Komisyonlar</h1>
        {profil?.rol !== 'temsilci' && seciliTemsilci && (
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-ghost btn-sm" onClick={() => { setTanimForm({ firma_id: '', oran: '' }); setTanimModal(true); }}>Oran</button>
            <button className="btn btn-sm" style={{ background: 'rgba(239,68,68,0.1)', color: 'var(--red)', border: '1px solid rgba(239,68,68,0.4)' }} onClick={temsilciTumunuGeriAl} disabled={odemeKaydediliyor}>↩ Tümünü Geri Al</button>
          </div>
        )}
      </div>

      {profil?.rol !== 'temsilci' && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="form-group">
            <label className="label">Temsilci</label>
            <select className="select" value={seciliTemsilci} onChange={e => setSeciliTemsilci(e.target.value)}>
              <option value="">Temsilci Seçin</option>
              {temsilciler.map(t => <option key={t.id} value={t.id}>{t.ad} {t.soyad}</option>)}
            </select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <div className="form-group">
              <label className="label">Başlangıç</label>
              <input type="date" className="input" value={tarihBas} onChange={e => setTarihBas(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Bitiş</label>
              <input type="date" className="input" value={tarihBit} onChange={e => setTarihBit(e.target.value)} />
            </div>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={() => { setTarihBas(''); setTarihBit(''); }}>Temizle</button>
        </div>
      )}

      {seciliTemsilci && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 10, marginBottom: 12 }}>
            <div className="stat-card"><div className="stat-label">Kendi Satışları</div><div className="stat-value" style={{ color: 'var(--yellow)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(toplamHakEdilen)} ₺</div></div>
            {altTemsilciToplam > 0 && <div className="stat-card"><div className="stat-label">Alt Temsilci Payı</div><div className="stat-value" style={{ color: 'var(--accent)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(altTemsilciToplam)} ₺</div></div>}
            {altTemsilciToplam > 0 && <div className="stat-card"><div className="stat-label">Toplam Kazanç</div><div className="stat-value" style={{ color: 'var(--green)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(genelToplam)} ₺</div></div>}
            <div className="stat-card"><div className="stat-label">Ödenen (komisyon)</div><div className="stat-value" style={{ color: 'var(--green)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(toplamOdenen)} ₺</div></div>
            {toplamEldenMahsup > 0 && <div className="stat-card"><div className="stat-label">Elden Mahsup</div><div className="stat-value" style={{ color: 'var(--accent)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(toplamEldenMahsup)} ₺</div></div>}
            {toplamEldenMahsup > 0 && <div className="stat-card"><div className="stat-label">Nakit Ödenen (net)</div><div className="stat-value" style={{ color: 'var(--green)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(netOdenen)} ₺</div></div>}
            <div className="stat-card"><div className="stat-label">Bekleyen</div><div className="stat-value" style={{ color: bekleyen > 0 ? 'var(--red)' : 'var(--text)', fontSize: 15, whiteSpace: 'nowrap' }}>{fmt(bekleyen)} ₺</div></div>
          </div>

          {firmaKomisyon.length > 0 && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
              {firmaKomisyon.map(f => (
                <div key={f.firma} style={{ background: 'var(--bg2)', padding: '8px 12px', borderRadius: 'var(--r)', border: '1px solid var(--border)' }}>
                  <div style={{ fontSize: 11, color: 'var(--text2)' }}>{f.firma}</div>
                  <div style={{ fontWeight: 700, color: 'var(--yellow)', fontSize: 14 }}>{fmt(f.tutar)} ₺</div>
                </div>
              ))}
            </div>
          )}

          <div className="tabs">
            <button className={`tab-btn ${tab === 'detay' ? 'active' : ''}`} onClick={() => setTab('detay')}>Kendi Satışları</button>
            {altKomisyonlar.length > 0 && (
              <button className={`tab-btn ${tab === 'alt' ? 'active' : ''}`} onClick={() => setTab('alt')}>Alt Temsilci ({altKomisyonlar.length})</button>
            )}
            <button className={`tab-btn ${tab === 'odeme' ? 'active' : ''}`} onClick={() => setTab('odeme')}>Ödeme Geçmişi</button>
          </div>

          {tab === 'detay' && (
            <div>
              {/* Komisyon durumu filtresi */}
              <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
                {[['odenmemis', 'Ödenmemiş'], ['odenmis', 'Ödenmiş'], ['hepsi', 'Hepsi']].map(([k, l]) => (
                  <button key={k} className={`btn btn-sm ${komFiltre === k ? 'btn-primary' : 'btn-ghost'}`} onClick={() => { setKomFiltre(k); setSecili({}); }}>{l}</button>
                ))}
              </div>

              {(() => {
                const gosterilen = komisyonlar.filter(s =>
                  komFiltre === 'hepsi' ? true : komFiltre === 'odenmis' ? s.komisyon_odendi : !s.komisyon_odendi
                );
                if (loading) return <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Yükleniyor...</div>;
                if (gosterilen.length === 0) return <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Kayıt yok</div>;

                const yonetici = profil?.rol !== 'temsilci';
                const odenmemisSayisi = komisyonlar.filter(s => !s.komisyon_odendi).length;

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {/* Toplu secim cubugu — sadece Ödenmemiş filtresinde */}
                    {yonetici && odenmemisSayisi > 0 && komFiltre === 'odenmemis' && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: '8px 12px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
                          <input type="checkbox"
                            checked={seciliIdler.length === odenmemisSayisi && odenmemisSayisi > 0}
                            onChange={tumunuSec} />
                          Ödenmemişlerin tümünü seç
                        </label>
                        <span style={{ fontSize: 12, color: 'var(--text2)' }}>{seciliIdler.length} seçili</span>
                      </div>
                    )}

                    {gosterilen.map(s => {
                      const secilebilir = yonetici && !s.komisyon_odendi;
                      return (
                        <div key={s.id} style={{ background: s.komisyon_odendi ? 'rgba(34,197,94,0.06)' : 'var(--bg2)', border: `1px solid ${secili[s.id] ? 'var(--accent)' : s.komisyon_odendi ? 'rgba(34,197,94,0.4)' : 'var(--border)'}`, borderRadius: 'var(--r)', padding: 12 }}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                            {secilebilir && (
                              <input type="checkbox" style={{ marginTop: 3 }}
                                checked={!!secili[s.id]}
                                onChange={e => setSecili(prev => ({ ...prev, [s.id]: e.target.checked }))} />
                            )}
                            <div style={{ flex: 1 }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, alignItems: 'center' }}>
                                <span className="mono" style={{ color: 'var(--accent)', fontWeight: 700 }}>{s.siparis_no}</span>
                                <span style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(new Date(s.created_at).getTime() + 3 * 60 * 60 * 1000).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                              </div>
                              <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 4 }}>{s.firmalar?.ad}</div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontSize: 13 }}>{fmt(s.toplam_tutar)} ₺</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                  <span style={{ fontWeight: 700, color: 'var(--yellow)' }}>{fmt(s.toplam_komisyon)} ₺ kom.</span>
                                  {s.komisyon_odendi
                                    ? <span className="badge badge-green" style={{ whiteSpace: 'nowrap' }}>✓ Kom.</span>
                                    : <span className="badge badge-red" style={{ whiteSpace: 'nowrap' }}>Ödenmedi</span>}
                                </div>
                              </div>
                              {yonetici && s.komisyon_odendi && (
                                <div style={{ textAlign: 'right', marginTop: 6 }}>
                                  <button className="btn btn-ghost btn-sm" onClick={() => komisyonGeriAl(s.id)}>↩ Geri Al</button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>
          )}

          {tab === 'alt' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {altKomisyonlar.length === 0
                ? <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Alt temsilci kaydı yok</div>
                : altKomisyonlar.map(k => (
                  <div key={k.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontWeight: 600 }}>{k.kullanicilar?.ad} {k.kullanicilar?.soyad}</span>
                      <span className="mono" style={{ color: 'var(--accent)', fontSize: 12 }}>{k.siparisler?.siparis_no}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                      <span style={{ color: 'var(--text2)' }}>Toplam Komisyon: {fmt(k.toplam_komisyon)} ₺</span>
                      <span style={{ fontWeight: 700, color: 'var(--accent)' }}>Payın: {fmt(k.ust_temsilci_payi)} ₺</span>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {tab === 'odeme' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {odemeler.length === 0 ? <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Ödeme yok</div>
                : odemeler.map(o => {
                  const elden = Number(o.elden_tahsilat) || 0;
                  const net = (Number(o.tutar) || 0) - elden;
                  return (
                  <div key={o.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <div style={{ fontWeight: 700, color: 'var(--green)', fontSize: 16 }}>{fmt(net)} ₺ <span style={{ fontSize: 11, color: 'var(--text2)', fontWeight: 400 }}>net ödeme</span></div>
                        <div style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(new Date(o.odeme_tarihi || o.created_at).getTime() + 3 * 60 * 60 * 1000).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</div>
                      </div>
                      <div style={{ textAlign: 'right', fontSize: 12, color: 'var(--text2)' }}>
                        <div>Komisyon: {fmt(o.tutar)} ₺</div>
                        {elden > 0 && <div style={{ color: 'var(--accent)' }}>Elden mahsup: {fmt(elden)} ₺</div>}
                      </div>
                    </div>
                    {o.not_ && <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 6 }}>{o.not_}</div>}
                  </div>
                  );
                })}
            </div>
          )}
        </>
      )}

      {/* Secili siparisler icin sabit odeme cubugu */}
      {profil?.rol !== 'temsilci' && seciliIdler.length > 0 && komFiltre !== 'odenmis' && (
        <div className="odeme-cubugu-mobil" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'var(--bg2)', borderTop: '2px solid var(--accent)', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', zIndex: 50, boxShadow: '0 -4px 12px rgba(0,0,0,0.15)' }}>
          <div>
            <div style={{ fontWeight: 700 }}>{seciliIdler.length} sipariş seçili</div>
            <div style={{ fontSize: 13, color: 'var(--text2)' }}>Toplam komisyon: <b style={{ color: 'var(--yellow)' }}>{fmt(seciliToplam)} ₺</b></div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <label style={{ fontSize: 11, color: 'var(--text2)' }}>Elden tahsilat (mahsup) ₺</label>
            <input className="input" type="number" min="0" placeholder="0" value={eldenTahsilat}
              onChange={e => setEldenTahsilat(e.target.value)} style={{ width: 150 }} />
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 11, color: 'var(--text2)' }}>Ödenecek net</div>
            <div style={{ fontWeight: 800, fontSize: 18, color: 'var(--green)' }}>
              {fmt(seciliToplam - (Number(eldenTahsilat) || 0))} ₺
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-ghost" onClick={() => { setSecili({}); setEldenTahsilat(''); }}>Vazgeç</button>
            <button className="btn btn-primary" onClick={komisyonOde} disabled={odemeKaydediliyor}>
              {odemeKaydediliyor ? 'Kaydediliyor...' : '✓ Komisyon Ödendi İşaretle'}
            </button>
          </div>
        </div>
      )}

      {tanimModal && (
        <div className="modal-overlay" onClick={() => setTanimModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Komisyon Oranı Tanımla</h3>
            <div className="form-group"><label className="label">Firma</label><select className="select" value={tanimForm.firma_id} onChange={e => setTanimForm(f => ({ ...f, firma_id: e.target.value }))}><option value="">Firma Seçin</option>{firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}</select></div>
            <div className="form-group"><label className="label">Komisyon Oranı (%)</label><input className="input" type="number" step="0.01" value={tanimForm.oran} onChange={e => setTanimForm(f => ({ ...f, oran: e.target.value }))} placeholder="20.00" /></div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setTanimModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleTanimKaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
